<template>
  <div class="slider-container">
    <Transition name="slider">
      <slot />
    </Transition>
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.slider-container {
  position: relative;
}

.slider-enter-active {
  transition: transform 1.5s ease-in-out;
}

.slider-leave-active {
  transition: transform 1.5s ease-in-out;
}

.slider-enter-from {
  transform: translateX(100%);
}

.slider-leave-to {
  transform: translateX(-100%);
}
</style>
